// extracted by mini-css-extract-plugin
module.exports = {"gymSelector":"AddEditAdmin_gymSelector__2vT1J","fullAccess":"AddEditAdmin_fullAccess__2-7Eo"};